import type { DetectedLink } from '../../integrations';

export function detectGitHubLink(url: string): DetectedLink | null {
  const githubIssueMatch = url.match(
    /https?:\/\/github\.com\/([^/]+)\/([^/]+)\/issues\/(\d+)/i
  );
  if (githubIssueMatch) {
    return {
      url,
      integrationType: 'github',
      resourceType: 'issue',
      resourceId: githubIssueMatch[3],
      owner: githubIssueMatch[1],
      repo: githubIssueMatch[2],
    };
  }
  const githubPRMatch = url.match(
    /https?:\/\/github\.com\/([^/]+)\/([^/]+)\/pull\/(\d+)/i
  );
  if (githubPRMatch) {
    return {
      url,
      integrationType: 'github',
      resourceType: 'pull-request',
      resourceId: githubPRMatch[3],
      owner: githubPRMatch[1],
      repo: githubPRMatch[2],
    };
  }
  return null;
}
